import client from "FrontendJsAssets/common/client";
import { CancelToken } from "axios";

const lang = document.querySelector("html").getAttribute("lang");
let locale;
import(`Locale/${lang}`).then((module) => {
    locale = module.Switch;
});

const cancelTokens = {
    addresses: CancelToken.source(),
    dates: CancelToken.source(),
    times: CancelToken.source(),
    process: CancelToken.source(),
};

function cancelRequest(type) {
    if (!cancelTokens[type]) {
        return;
    }

    cancelTokens[type].cancel();
    cancelTokens[type] = CancelToken.source();
}

const actions = {
    fetchAddresses({ state, commit, dispatch, getters }, newAddressId = null) {
        cancelRequest("addresses");
        cancelRequest("dates");
        cancelRequest("times");

        commit("DISABLE_DATES");
        commit("DISABLE_TIMES");

        return client
            .get("/switch-fetch-addresses", {
                cancelToken: cancelTokens.addresses.token,
            })
            .then((response) => {
                if (!response.data.status) {
                    return;
                }

                const effectiveAddressId = newAddressId != null ? newAddressId : response.data.selectedAddressId;

                commit("SET_SELECTED_ADDRESS_ID", effectiveAddressId);
                commit("SET_AUTOCOMPLETE_VALUE", response.data.autocompleteValue);

                // Only mark autocomplete as used if the selected address is actually a route from autocomplete (starts with "R")
                if (response.data.autocompleteValue.trim() !== "" && String(response.data.selectedAddressId).startsWith("R")) {
                    commit("SET_AUTOCOMPLETE_ADDRESS_IS_USED", true);
                }

                if (state.modalData && state.modalData.activeTab) {
                    commit("SET_ACTIVE_ADDRESSES_TAB", state.modalData.activeTab);
                } else {
                    commit("SET_ACTIVE_ADDRESSES_TAB", getters.activeTabFromAddress);
                }

                commit("SET_ADDRESSES", response);
                commit("ENABLE_ADDRESSES");

                if (effectiveAddressId != null) {
                    commit("SET_WANNA_CHANGE_ADDRESS", false);
                    dispatch("fetchDates");
                } else {
                    commit("SET_WANNA_CHANGE_ADDRESS", true);
                }

                // If address data was passed from index switch, set it and process
                if (state.modalData && state.modalData.autocompletePostCode) {
                    commit("SET_AUTOCOMPLETE_ADDRESS", {
                        postCode: state.modalData.autocompletePostCode,
                        city: state.modalData.autocompleteCity,
                        street: state.modalData.autocompleteStreet,
                        fullAddress: state.modalData.autocompleteValue,
                    });
                    dispatch("processAddress");
                }
            })
            .catch((error) => {
                if (error?.__CANCEL__) {
                    return;
                }

                Eshop.alert(error.response?.data?.message || error?.message || error, {
                    type: "error",
                });
            });
    },
    fetchDates({ commit, dispatch, state }) {
        cancelRequest("dates");
        cancelRequest("times");

        commit("DISABLE_DATES");
        commit("DISABLE_TIMES");
        commit("SET_DATES_ERROR_MESSAGE", false);

        return client
            .get(`/switch-fetch-dates/${state.selectedAddressId}`, {
                cancelToken: cancelTokens.dates.token,
            })
            .then((response) => {
                if (!response.data.status) {
                    commit(
                        "SET_DATES_ERROR_MESSAGE",
                        response.data.message || locale.Dates.fetchError
                    );

                    return;
                }

                commit("SET_SELECTED_DATE_ID", response.data.selectedDateId);
                commit("SET_DATES", response);
                commit("ENABLE_DATES");

                dispatch("fetchTimes");
            })
            .catch((error) => {
                if (error?.__CANCEL__) {
                    return;
                }

                Eshop.alert(error.response?.data?.message || error?.message || error, {
                    type: "error",
                });
            });
    },
    fetchTimes({ commit, state }) {
        cancelRequest("times");

        commit("DISABLE_TIMES");

        return client
            .get(`/switch-fetch-times/${state.selectedAddressId}/${state.selectedDateId}`, {
                cancelToken: cancelTokens.times.token,
            })
            .then((response) => {
                if (!response.data.status) {
                    return;
                }

                commit("SET_SELECTED_TIME_ID", response.data.selectedTimeId);
                commit("SET_TIMES", response);
                commit("ENABLE_TIMES");
            })
            .catch((error) => {
                if (error?.__CANCEL__) {
                    return;
                }

                Eshop.alert(error.response?.data?.message || error?.message || error, {
                    type: "error",
                });
            });
    },
    changeAddress({ commit, dispatch }, addressId) {
        commit("HIDE_ALL_ADDRESSES");

        commit("SET_SELECTED_ADDRESS_ID", addressId);
        commit("SET_AUTOCOMPLETE_ADDRESS_IS_USED", false);
        commit("SET_PROCESS_ERROR_MESSAGE", false);

        dispatch("fetchDates");
        // commit("SET_WANNA_CHANGE_ADDRESS", false);
    },
    processAddress({ commit, dispatch, state }, addingNewAddress = false) {
        cancelRequest("dates");
        cancelRequest("times");

        if (!addingNewAddress) {
            commit("DISABLE_DATES");
            commit("DISABLE_TIMES");
        }

        commit("SET_PROCESS_ERROR_MESSAGE", false);

        return client
            .get("/switch-process-address", {
                params: {
                    postCode: state.autocompletePostCode,
                    city: state.autocompleteCity,
                    street: state.autocompleteStreet,
                },
                cancelToken: cancelTokens.process.token,
            })
            .then((response) => {
                if (!response.data.status) {
                    commit(
                        "SET_PROCESS_ERROR_MESSAGE",
                        response.data.message || locale.Addresses.processError
                    );
                    commit("SET_SELECTED_ADDRESS_ID", response.data.selectedAddressId);

                    return;
                }

                if (!addingNewAddress) {
                    commit("SET_SELECTED_ADDRESS_ID", response.data.selectedAddressId);
                    commit("SET_AUTOCOMPLETE_ADDRESS_IS_USED", true);

                    dispatch("fetchDates");

                    commit("SET_WANNA_CHANGE_ADDRESS", false);
                } else {
                    commit("SET_NEW_ADDRESS_CHECKED", true);
                    commit("SET_NEW_ADDRESS_DATA", response.data);
                }
            })
            .catch((error) => {
                if (error?.__CANCEL__) {
                    return;
                }

                Eshop.alert(error.response?.data?.message || error?.message || error, {
                    type: "error",
                });
            });
    },
    submitSwitch({ commit, state }) {
        return client
                .post("/custom-modal-switch-submit", {
                    "switch-address": state.selectedAddressId,
                    "switch-date": state.selectedDateId,
                    "switch-time": state.selectedTimeId,
                })
                .then((response) => {
                    if (!response.data.status) {
                        Eshop.alert(response.data.message, {
                            type: "error",
                        });

                        commit("SET_SWITCH_IS_SUBMITTING", false);

                        return;
                    }

                    // Refresh the current URL in the Riesenia wrapper without a native RELOAD.
                    if (window.AppBridge && window.AppBridge.isApp) {
                        window.location.reload();
                    } else {
                        window.reloadPage();
                    }
                })
                .catch((error) => {
                    if (error && error.__CANCEL__) {
                        return;
                    }
                    Eshop.alert((error.response && error.response.data && error.response.data.message) || error.message || error, {
                        type: "error",
                    });
                });
    },
    submitNewAddress({ commit, state, dispatch }) {
        return client
            .post("/users/create-address", {
                "name": state.newAddressData.name,
                "company": state.newAddressData.company,
                "city": state.newAddressData.city,
                "post_code": state.newAddressData.postCode,
                "address": state.newAddressData.address,
                "phone": state.newAddressData.phone,
                "country_id": state.newAddressData.countryId,
            })
            .then((response) => {
                if (!response.data.status) {
                    Eshop.alert(response.data.message, {
                        type: "error",
                    });

                    commit("SET_ADDRESS_IS_SUBMITTING", false);

                    return;
                }

                if (state.modalData && !state.modalData.onlyAddress) {
                    commit("SET_ADDRESS_IS_SUBMITTING", false);
                    commit("SET_NEW_ADDRESS_CHECKED", false);
                    commit("SET_MAIN_COMPONENT", "MainSwitch");
                    commit("SET_WANNA_CHANGE_ADDRESS", false);

                    if (response.data.newId != null) {
                        dispatch("fetchAddresses", response.data.newId);
                    }
                } else {
                    Eshop.alert(response.data.message, {
                        type: "success",
                    });

                    setTimeout(() => {
                        if (window.AppBridge && window.AppBridge.isApp) {
                            window.location.reload();
                        } else {
                            window.reloadPage();
                        }
                    }, 500);
                }
            })
            .catch((error) => {
                if (error && error.__CANCEL__) {
                    return;
                }
                Eshop.alert((error.response && error.response.data && error.response.data.message) || error.message || error, {
                    type: "error",
                });
            });
    },
    getAvailableCountries({ commit }) {
        return client
            .get("/get-available-countries")
            .then((response) => {
                if (!response.data.status) {
                    return;
                }

                commit("SET_AVAILABLE_COUNTRIES", response.data.countries);
            })
            .catch((error) => {
                if (error && error.__CANCEL__) {
                    return;
                }

                Eshop.alert((error.response && error.response.data && error.response.data.message) || error.message || error, {
                    type: "error",
                });
            });
    },
};

export default actions;
